import * as React from 'react';
import { Popover } from 'radix-ui';
import { usePopup } from './popup.context';
import { useForkedRef } from '@dx-ui/utilities-use-forked-ref';

type PopupButtonProps = {
  onArrowDownWhenOpen?: () => void;
} & React.ComponentPropsWithRef<'button'>;

const PopupButton = ({
  ref: forwardedRef,
  children,
  onArrowDownWhenOpen,
  ...rest
}: PopupButtonProps) => {
  const { triggerRef, popupId, isOpen, setOpen } = usePopup();
  const ref = useForkedRef(forwardedRef, triggerRef as React.RefObject<HTMLButtonElement | null>);

  const onKeyDown = (e: React.KeyboardEvent) => {
    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        setOpen(!isOpen);
        if (isOpen) {
          onArrowDownWhenOpen?.();
        }
        break;
      default:
        break;
    }
  };

  return (
    <Popover.Trigger asChild>
      <button
        ref={ref}
        type="button"
        onKeyDown={onKeyDown}
        aria-expanded={isOpen ? 'true' : 'false'}
        aria-controls={popupId}
        {...rest}
      >
        {children}
      </button>
    </Popover.Trigger>
  );
};

export { PopupButton };
export default PopupButton;
